'use strict';

var defineProperty = require('../../node_modules/@babel/runtime/helpers/defineProperty.js');
var React = require('react');
var iconStyles = require('../iconStyles.js');
var SvgIcon = require('../../node_modules/@material-ui/core/esm/SvgIcon/SvgIcon.js');

function _interopDefaultLegacy (e) { return e && typeof e === 'object' && 'default' in e ? e : { 'default': e }; }

var React__default = /*#__PURE__*/_interopDefaultLegacy(React);

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(Object(source), true).forEach(function (key) { defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(Object(source)).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

var PayrollAppIcon = function PayrollAppIcon(props) {
  return React__default["default"].createElement(SvgIcon["default"], _objectSpread({}, props, {
    viewBox: "20 20 130 130"
  }), React__default["default"].createElement("defs", null, React__default["default"].createElement("style", null, ".cls-2{fill:#13191e}")), React__default["default"].createElement("g", {
    id: "Icons"
  }, React__default["default"].createElement("path", {
    d: "M127.63 76.13a2.5 2.5 0 0 1-2.5-2.5v-14.7a2.5 2.5 0 0 1 5 0v14.7a2.5 2.5 0 0 1-2.5 2.5ZM90.25 135.95H39.97c-6.34 0-11.5-5.16-11.5-11.5V58.93a2.5 2.5 0 0 1 5 0v65.52c0 3.58 2.92 6.5 6.5 6.5h50.29a2.5 2.5 0 0 1 0 5Z",
    className: "cls-2"
  }), React__default["default"].createElement("path", {
    d: "M118.63 135.95H53.11a2.5 2.5 0 0 1 0-5h65.52c3.58 0 6.5-2.92 6.5-6.5v-11.5a2.5 2.5 0 0 1 5 0v11.5c0 6.34-5.16 11.5-11.5 11.5ZM127.63 61.4H30.97c-1.04 0-1.88-.84-1.88-1.88V45.24c0-5.7 4.64-10.33 10.33-10.33h11.07c1.04 0 1.88.84 1.88 1.88s-.84 1.88-1.88 1.88H39.42c-3.63 0-6.58 2.95-6.58 6.58v12.4h92.91v-12.4c0-3.63-2.95-6.58-6.58-6.58H108.1c-1.04 0-1.88-.84-1.88-1.88s.84-1.88 1.88-1.88h11.07c5.7 0 10.33 4.64 10.33 10.33v14.28c0 1.04-.84 1.88-1.88 1.88Z",
    className: "cls-2"
  }), React__default["default"].createElement("path", {
    d: "M33.47 59.53h-5V45.25c0-6.04 4.92-10.96 10.96-10.96H50.5v5H39.43c-3.29 0-5.96 2.67-5.96 5.96v14.28ZM130.13 59.53h-5V45.25c0-3.29-2.67-5.96-5.96-5.96H108.1v-5h11.07c6.04 0 10.96 4.92 10.96 10.96v14.28ZM61.84 34.29h34.58v5H61.84z",
    className: "cls-2"
  }), React__default["default"].createElement("path", {
    d: "M57.02 50.91h-1.7c-3.69 0-6.7-3-6.7-6.7V29.37c0-3.69 3-6.7 6.7-6.7h1.7c3.69 0 6.7 3 6.7 6.7v14.84c0 3.69-3 6.7-6.7 6.7Zm-1.7-24.48c-1.63 0-2.95 1.32-2.95 2.95v14.84c0 1.62 1.32 2.95 2.95 2.95h1.7c1.63 0 2.95-1.32 2.95-2.95V29.38c0-1.62-1.32-2.95-2.95-2.95h-1.7ZM103.27 50.91h-1.7c-3.69 0-6.7-3-6.7-6.7V29.37c0-3.69 3-6.7 6.7-6.7h1.7c3.69 0 6.7 3 6.7 6.7v14.84c0 3.69-3 6.7-6.7 6.7Zm-1.7-24.48c-1.63 0-2.95 1.32-2.95 2.95v14.84c0 1.62 1.32 2.95 2.95 2.95h1.7c1.62 0 2.95-1.32 2.95-2.95V29.38c0-1.62-1.32-2.95-2.95-2.95h-1.7Z",
    className: "cls-2"
  }), React__default["default"].createElement("rect", {
    width: 10.49,
    height: 10.49,
    x: 63.79,
    y: 72.22,
    className: "cls-2",
    rx: 1.05,
    ry: 1.05
  }), React__default["default"].createElement("rect", {
    width: 10.49,
    height: 10.49,
    x: 84.31,
    y: 72.22,
    className: "cls-2",
    rx: 1.05,
    ry: 1.05
  }), React__default["default"].createElement("rect", {
    width: 10.49,
    height: 10.49,
    x: 43.27,
    y: 90.43,
    className: "cls-2",
    rx: 1.05,
    ry: 1.05
  }), React__default["default"].createElement("rect", {
    width: 10.49,
    height: 10.49,
    x: 43.27,
    y: 72.22,
    className: "cls-2",
    rx: 1.05,
    ry: 1.05
  }), React__default["default"].createElement("rect", {
    width: 10.49,
    height: 10.49,
    x: 63.79,
    y: 90.43,
    className: "cls-2",
    rx: 1.05,
    ry: 1.05
  }), React__default["default"].createElement("rect", {
    width: 10.49,
    height: 10.49,
    x: 84.31,
    y: 90.43,
    rx: 1.05,
    ry: 1.05,
    style: {
      fill: "#0f77cc"
    }
  }), React__default["default"].createElement("rect", {
    width: 10.49,
    height: 10.49,
    x: 43.27,
    y: 108.63,
    className: "cls-2",
    rx: 1.05,
    ry: 1.05
  }), React__default["default"].createElement("rect", {
    width: 10.49,
    height: 10.49,
    x: 63.79,
    y: 108.63,
    className: "cls-2",
    rx: 1.05,
    ry: 1.05
  }), React__default["default"].createElement("rect", {
    width: 10.49,
    height: 10.49,
    x: 84.31,
    y: 108.63,
    className: "cls-2",
    rx: 1.05,
    ry: 1.05
  }), React__default["default"].createElement("path", {
    d: "M127.63 115.45c-12.22 0-22.16-9.94-22.16-22.16s9.94-22.16 22.16-22.16 22.16 9.94 22.16 22.16-9.94 22.16-22.16 22.16Zm0-39.33c-9.46 0-17.16 7.7-17.16 17.16s7.7 17.16 17.16 17.16 17.16-7.7 17.16-17.16-7.7-17.16-17.16-17.16Z",
    className: "cls-2"
  }), React__default["default"].createElement("text", {
    style: {
      fontFamily: "HelveticaNeue-Medium,&quot",
      fontSize: "27.34px",
      fill: "#0f77cc"
    },
    transform: "translate(119.75 103.46)"
  }, React__default["default"].createElement("tspan", {
    x: 0,
    y: 0
  }, "$")), React__default["default"].createElement("path", {
    d: "M0 0h158v158H0z",
    style: {
      fill: "none"
    }
  })));
};

var PayrollAppIcon$1 = iconStyles()(PayrollAppIcon);

module.exports = PayrollAppIcon$1;
